// src/lib/betaConfig.js
//
// Single source of truth for what beta testers see in the welcome modal
// and feedback button. Edit here, both UIs update.
//
// Add new perks/features here; the BetaWelcomeModal renders these arrays
// directly so there's no copy-paste between components.

// Assistant-coach framing. Each entry says what Scrimly DOES for
// you (action verb), not just what features exist (noun list).
// This is the wedge against TeamSnap and others: stores data vs
// takes action.
export const BETA_FEATURES = [
  {
    icon: '⛈️',
    title: 'Watches the weather',
    body: 'Storm in the forecast for tonight\'s practice? Scrimly pings you to cancel or proceed. You tap one button, parents get a bilingual message in their preferred language. You didn\'t write a thing.',
  },
  {
    icon: '💳',
    title: 'Handles the money',
    body: 'Stripe-powered registration and payments at-cost. Scrimly tracks who\'s paid, sends installment reminders 3 days before each charge, and gives you clean financial reports. You don\'t chase anyone.',
  },
  {
    icon: '🔔',
    title: 'Nudges non-responders',
    body: 'A game on Saturday with two parents who haven\'t RSVP\'d? Scrimly nudges only them, in the language they read best. Your inbox stays clean.',
  },
  {
    icon: '✨',
    title: 'Drafts your messages',
    body: 'Game recap, schedule change, payment reminder, tryout invite. Scrimly\'s AI drafts it in English and Spanish in 30 seconds. You edit if you want, send when ready.',
  },
  {
    icon: '🎯',
    title: 'Surfaces your decisions',
    body: 'Open the dashboard. Scrimly tells you "16 unpaid registrations, 3 days until close, 2 missing waivers." Not stats to interpret. A list of decisions waiting on you.',
  },
  {
    icon: '⚽',
    title: 'Brings scrimmage matching back',
    body: 'The original Scrimly use case is returning later this year as a feature inside the broader tool. Every club that joins now seeds the eventual matching pool.',
  },
]

export const BETA_PERKS = [
  {
    icon: '🆓',
    title: 'Team tier free for 1 year',
    body: 'No credit card needed. $29/mo value.',
  },
  {
    icon: '💰',
    title: '50% off any tier for 2 more years',
    body: 'Locked-in pricing after your free year ends.',
  },
  {
    icon: '📱',
    title: 'Direct line to Kurt',
    body: 'Reply to any email or use the bug button. You get a real answer, not a ticket.',
  },
  {
    icon: '🚀',
    title: 'First crack at new features',
    body: 'See and test new things before public release.',
  },
]

export const BETA_ASKS = [
  'Use it when it\'s useful',
  'Tell me when something breaks',
  'Reply when I ask for feedback',
  'If you like it, tell another coach',
]

export const BETA_FOUNDING_CLUB = {
  title: 'Running a club, not just a team?',
  body:
    'Beta testers running a club get first dibs on the Founding Club program: ' +
    'Growth tier ($349/mo retail) locked at $199/mo for life, Stripe at-cost forever, ' +
    'free migration, and weekly check-ins. First 5 founding clubs only.',
}

// Where feedback lands. Firestore writes are the primary channel; the
// mailto fallback is shown alongside so coaches always have a path even
// if Firestore rules aren't open yet.
export const BETA_FOUNDER_EMAIL = 'kurt@getscrimly.com'
